module.exports = __webpack_public_path__ + "img/bear-face-icon-2.f0e413aa.png";